// Form: Contact
// 

JLM.MD.FormContact = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let f_name, f_email, f_phone, f_subject, f_message, but_submit;
	
	// Values
	let talent_id, talent_division;
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Data
		const data_subjects = JLM.database.getDataFromPage('jl_form_subjects');
		
		// Values
		talent_id = $('#enquiry_talent_id').val();
		talent_division = $('#enquiry_talent_division').val();
		
		// Define references
		f_name = new JLM.MD.Textfield( $('#f_contact_name', container) );
		f_email = new JLM.MD.Textfield( $('#f_contact_email', container) );
		f_phone = new JLM.MD.Textfield( $('#f_contact_phone', container) );
		f_subject = new JLM.MD.DropdownList( $('#f_contact_subject', container), data_subjects );
		f_message = new JLM.MD.Textfield( $('#f_contact_message', container) );
		but_submit = $('button[type="submit"]', container);
		
		// Events
		// f_name.on('change', onFormUpdate);
		// f_email.on('change', onFormUpdate);
		// f_phone.on('change', onFormUpdate);
		// f_message.on('change', onFormUpdate);
		but_submit.on('click', onSubmit);
		
		// Auto-focus
		// f_name.focus();
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// When form inputs change
	// 
	function onFormUpdate() {
		/*
		if ( f_name.value && f_email.value && f_phone.value && f_message.value ) {
			but_submit.prop('disabled', false);
		} else {
			but_submit.prop('disabled', true);
		}
		*/
	}
	
	
	// Attempt to submit form
	// 
	function onSubmit( event ) {
		const form_values = validateForm();
		if ( form_values ) {
			// Disable form
			disableForm();
			let icon = new JLM.MD.IconLoading( but_submit );
			
			// Get CSRF values
			$.get('/api/tokens/csrf')
				.done(function( response ) {
					// Attach CSRF values
					form_values.csrf_name = response.name;
					form_values.csrf_value = response.value;
					
					// Send message
					$.post('/api/contact/send', form_values)
						.done(function( response ) {
							if ( response.success == 1 ) {
								$('form', container).addClass('sent');
							} else {
								alert( response.error );
								icon.remove();
								enableForm();
							}
						})
						.fail(function( event ) {
							alert('Message was not sent - failure to connect to server');
							icon.remove();
							enableForm();
						});
				})
				.fail(function( event ) {
					alert('Message was not sent - failure to connect to server');
					icon.remove();
					enableForm();
				});
		}
		
		// Cancel button event
		event.preventDefault();
	}
	function validateForm() {
		let is_valid = true,
			form_values = { name: null, email: null, phone: null, subject: null, message: null };
		
		// Name
		form_values.name = $.trim( f_name.value );
		if ( form_values.name === '' ) {
			f_name.showError();
			is_valid = false;
		}
		
		// Email
		form_values.email = $.trim( f_email.value );
		if ( !JLM.MT.isValidEmailAddress( form_values.email ) ) {
			f_email.showError();
			is_valid = false;
		}
		
		// Phone
		form_values.phone = $.trim( f_phone.value );
		if ( form_values.phone === '' ) {
			f_phone.showError();
			is_valid = false;
		}
		
		// Subject
		form_values.subject = f_subject.value;
		
		// Message
		form_values.message = $.trim( f_message.value );
		// if ( form_values.message === '' ) {
		//	f_message.showError();
		//	is_valid = false;
		// }
		
		// Talent data
		if ( talent_id && talent_division ) {
			form_values.talent_id = talent_id;
			form_values.talent_division = talent_division;
		}
		
		// Response
		if ( is_valid ) {
			return form_values;
		}
		return is_valid;
	}
	
	
	// Disable/Enable form
	// 
	function disableForm() {
		f_name.disable();
		f_email.disable();
		f_phone.disable();
		f_subject.disable();
		f_message.disable();
		but_submit.prop('disabled', true);
	}
	function enableForm() {
		f_name.enable();
		f_email.enable();
		f_phone.disable();
		f_subject.enable();
		f_message.enable();
		$('.label', but_submit).text('Send Enquiry');
		but_submit.prop('disabled', false);
	}
	
	
	// Methods: Public __________________________________________________________
	
	// Focus on first input on form
	// 
	INSTANCE.focus = function() {
		f_name.focus();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};